import type { PcmBuffer } from './types';

// Slice a buffer between [startSeconds, endSeconds]. End defaults to the
// buffer's length when omitted. Both bounds clamp into the buffer — so
// passing -1s..+∞s gives you the full buffer back, not an error.

export type TrimOptions = {
  startSeconds?: number;
  endSeconds?: number;
};

export function trim(pcm: PcmBuffer, opts: TrimOptions): PcmBuffer {
  const totalFrames = pcm.channels[0]?.length ?? 0;
  const startFrame = clampFrame(
    Math.round((opts.startSeconds ?? 0) * pcm.sampleRate),
    totalFrames,
  );
  const endFrame = clampFrame(
    Math.round((opts.endSeconds ?? Infinity) * pcm.sampleRate),
    totalFrames,
  );
  const from = Math.min(startFrame, endFrame);
  const to = Math.max(startFrame, endFrame);
  const channels = pcm.channels.map((ch) => ch.slice(from, to));
  return { sampleRate: pcm.sampleRate, channels };
}

function clampFrame(n: number, total: number): number {
  if (!Number.isFinite(n)) return total;
  if (n < 0) return 0;
  if (n > total) return total;
  return n;
}
